import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { startWith, map, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { PersonalService } from '../../../services/personal.service';

@Component({
  selector: 'app-combo-autocomplete',
  templateUrl: './combo-autocomplete.component.html',
  styleUrls: ['./combo-autocomplete.component.css']
})

export class ComboAutocompleteComponent implements OnInit {

  //La tabla es una opcion por si el combo se utiliza para otra cosa aparte de Personal
  @Input() tabla: string;
  
  searchControl = new FormControl();
  filteredOptions: Observable<any[]>;
  isInputFocused = false;

  constructor(private personalService: PersonalService,
              private router: Router) 
  {
    this.iniciarOptions();
  }

  public ngOnInit():any {
    
  }

  iniciarOptions()
  {
    this.filteredOptions = this.searchControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300), // Espera 300 ms después de la última pulsación de tecla
      distinctUntilChanged(), // Emite solo si el valor cambia
      switchMap(value => {
        if (value.length >= 3) {
          return this.searchAPI(value);
        } else {
          return [];
        }
      })
    );
  }

  searchAPI(value: string): Observable<any[]> {

    switch(this.tabla) { 
      case 'Personal': { 
        return this.personalService.getListByName(value);    
        break; 
      }
      default: { 
        return this.personalService.getListByName(value);
        break; 
      } 
    };  
    
  }

  displayOption(option: any): string {
    let mostrar = "";
    switch(this.tabla) { 
      case 'Personal': { 
        mostrar = option.code + " - " + option.displayName;
        break; 
      }
      default: { 
        mostrar = option.code + " - " + option.displayName;
        break; 
      } 
    };      

    return mostrar ;
  }

  selectedOption(event: any) : void {
    const selectedOption = event.option.value;
    this.searchControl.reset();
    this.iniciarOptions();

    switch(this.tabla) { 
      case 'Personal': { 
        this.router.navigate(['gestionar', {legajo: selectedOption.code}]);
        break; 
      }
      default: { 
        this.router.navigate(['gestionar', {legajo: selectedOption.code}]);
        break; 
      } 
    };     
  }

}
